export default __webpack_public_path__ + "static/media/phone white.e0114bcd.svg";